<script>
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosyafirma from "@/models/satdosyafirma";
import AddEdit from "./addedit.vue";
import satdosyafirmafiyat from "../satdosyafirmafiyat/addedit.vue";
import yaklasikmaliyetgorevlileri from "./yaklasikmaliyetgorevlileri.vue";
import yaklasikmaliyetcetveli from "./yaklasikmaliyetcetveli.vue";
import moment from "moment";

export default {
  props: ["satdosyaId", "StrBirimHarcamaLimitTutari"],
  mixins: [apibtoast, apigeneric, satdosyafirma],
  page: {
    title: "Satın Alma Firmalar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    AddEdit,
    satdosyafirmafiyat,
    yaklasikmaliyetgorevlileri,
    yaklasikmaliyetcetveli,
  },
  data() {
    return {
      title: this.$t("satdosyafirma.Title"),
      items: [
        {
          text: this.$t("satdosyafirma.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("satdosyafirma.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("satdosyafirma.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      TableData2: {},
      DataUpdate: "",
      AddEdit: "",
      FirmaId: "",
      Firmaadi: "",
      yaklasikmaliyetgorevlileriac: false,
      MaliyetCetveliUpdate: false,
      SatDosya: null,
      Yaklasikmaliyetdosyasi: null,
      YMCStartup: 0,
      GetBirimButceTutar: null,
      Fiyatturu: null,
      Kaydet: null,
      BirimFiyatAddEdit: "",

    };
  },

  methods: {
    Get() {
      this.ActionsSingleGet({ Service: "SatDosya", Id: this.satdosyaId }).then((res) => {
        if (res && Object.keys(res.Data).length > 0) {
          this.SatDosya = res.Data;
          if (this.SatDosya.yaklasikmaaliyetbirimfiyat == true) {
            this.Fiyatturu = 4;
          } else {
            this.Fiyatturu = 1;
          }
          this.SatDosya.Yaklasikmaliyetwebsitesontarih = this.$options.filters.formatDate(this.SatDosya.Yaklasikmaliyetwebsitesontarih);
          this.ActionsFilterGet({ "Service": "satdosyafirma", "Page": this.Page, "Filter": "&Dosyaid=" + this.satdosyaId + "&Firmaid=" + res.Data.Ihaleyiyapanmakam }).then((resp) => {
            this.BirimFiyatAddEdit = resp.Data
            if (resp.Data.length > 0) {
              this.BirimFiyatAddEdit = 'Edit';
            } else {
              this.BirimFiyatAddEdit = 'Add';
            }
          });
          if (this.SatDosya.yaklasikmaaliyetbirimfiyat == true) {
            this.ActionsFilterGet({ "Service": "satdosyafirma", "Page": this.Page, "Filter": "&Dosyaid=" + this.satdosyaId + "&Firmaturu=4" }).then((res) => {
              this.TableData = res.Data;
              this.Page.PageDataSize = res.TotalCount;
              this.$emit("aktif_menu_title", this.$t('satdosyafirma.Title'));

              this.ActionsFilterGet({ "Service": "satdosyafirma", "Page": this.Page, "Filter": "&Dosyaid=" + this.satdosyaId + "&Firmaturu=2" }).then((res2) => {
              this.TableData2 = res2.Data;

            });
            });
          } else {
            this.ActionsFilterGet({ "Service": "satdosyafirma", "Page": this.Page, "Filter": "&Dosyaid=" + this.satdosyaId + "&Firmaturu=1" }).then((res) => {
              this.TableData = res.Data;
              this.Page.PageDataSize = res.TotalCount;
              this.$emit("aktif_menu_title", this.$t('satdosyafirma.Title'));
            });
          }


        }
      });
    },
    GetBirimButceTutari(Data) {
      this.GetBirimButceTutar = Data;
    },
    DosyaUpdate() {
      if (this.SatDosya.Yaklasikmaliyetwebsite == true) {
        this.SatDosya.Websiteverigirislink =
          window.location.protocol + "//" +
          window.location.host +
          "/yaklasikmaliyetgiris/"
      }
      const originalDate = new Date();
      const futureDate = moment(originalDate).add(5, 'days').format("YYYY-MM-DD");
      if (this.SatDosya.Yaklasikmaliyetwebsitesontarih >= futureDate) {
        this.SatDosya.Yaklasikmaliyetwebsiteilktarih = originalDate;
        this.Update("satdosya", this.SatDosya).then((res) => {
          if (res) {
            this.$emit("TableUpdate");
            if (this.SatDosya.Yaklasikmaliyetwebsite == true) {
              this.ActionsFilterGet({ "Service": "OFirma", "Page": this.Page, "Filter": "&Turid=" + this.SatDosya.Alimturu }).then((resp) => {
                for (var i = 0; i < resp.Data.length; i++) {
                  let MailData = {
                    Message: "Sayın Firma; Üniversitemizce Doğrudan Temin Usulü ile '" + this.SatDosya.Dosyaadi + "' isimli " + "alımı https://satinalma.erdogan.edu.tr/yayinlananihaleler adresinden tekliflere açılmıştır. Bilginize...",
                    Recievermailadress: resp.Data[i].Email,
                    Subject: "Satın Alma Otomasyonu Bilgilendirme",
                  };
                  this.Post("TsvBildirimTanim/SendInvite", MailData)
                }
              });

            }
          }
        });

      } else {
        this.$toast.error('Son ilan tarihi, bugünden en az 5 gün sonrası olarak seçilmelidir.');
      }
    },
    TutarGuncelle() {
      this.$emit("TableUpdate");
    },
    BirimFiyatEkle() {
      this.satdosyafirmaData.Firmaturu = 4;
      this.satdosyafirmaData.Dosyaid = this.satdosyaId;
      this.satdosyafirmaData.Firmaid = this.SatDosya.Ihaleyiyapanmakam;
      if (this.BirimFiyatAddEdit == "Add")
        this.Post("satdosyafirma", this.satdosyafirmaData)
    }
  },
  watch: {
    satdosyaId() {
      this.Get();
    },
    SatDosya() {

    }

  },

};
</script>

<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-sm-12">
              <div class="text-sm-end">
                <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.satdosyafirma
                  @click="(DataUpdate = satdosyafirmaData), (AddEdit = 'Add')"
                  v-if="!SatDosya.Tamamlandi && !SatDosya.yaklasikmaaliyetbirimfiyat">
                  <i class="mdi mdi-plus me-1"></i>{{ $t("satdosyafirma.Page.YeniKayitEkle") }}
                </button>
                <button type="button" class="btn btn-warning btn-rounded mb-2 me-2"
                  v-b-modal.yaklasikmaliyetgorevlileri>
                  <i class="fas fa-user-plus"></i>
                  {{ $t("satdosyafirma.Page.YaklasikMaliyetGorevlileri") }}
                </button>
                <button type="button" class="btn btn-info btn-rounded mb-2 me-2"
                  v-if="SatDosya.yaklasikmaaliyetbirimfiyat"
                  @click="BirimFiyatEkle(), (FirmaId = this.SatDosya.Ihaleyiyapanmakam), (Firmaadi = 'Birim Fiyatlar'), (Fiyatturu = 4), (AddEdit = 'Add')"
                  v-b-modal.satdosyafirmafiyat>
                  <i class="mdi mdi-plus me-1"></i>
                  {{ $t("satdosyafirma.Page.AddBirimFiyat") }}
                </button>
                <button type="button" class="btn btn-success btn-rounded mb-2 me-2" v-b-modal.yaklasikmaliyetcetveli
                  @click="(DataUpdate = satdosyafirmaData), (YMCStartup += parseInt(1))"
                  v-tooltip="$t('satdosyafirma.Page.YMCButtonHover')">
                  <i class="mdi mdi-file-export-outline me-1"></i>
                  {{ $t("satdosyafirma.Page.YaklasikMaliyetCetveli") }}
                </button>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="row">
                <div class="col-md-5">
                  <b-form-group
                    :label="SatDosya.yaklasikmaaliyetbirimfiyat != true ? 'YM/Piyasa Fiyat Arşt. İçin Web Sitesinde Yayınla' : 'Piyasa Fiyat Arşt. İçin Web Sitesinde Yayınla'"
                    label-for="text">
                    <b-form-checkbox value=true unchecked-value=false v-model="SatDosya.Yaklasikmaliyetwebsite"
                      class="mb-3" checked plain
                      @input="SatDosya.Yaklasikmaliyetwebsite = JSON.parse(SatDosya.Yaklasikmaliyetwebsite)"></b-form-checkbox>
                  </b-form-group>
                </div>
         <div class="col-md-5">
                  <b-form-group v-if="SatDosya.Yaklasikmaliyetwebsite" id="example text"
                    :label="SatDosya.yaklasikmaaliyetbirimfiyat != true ? 'YM/Piyasa Fiyat Arşt. İçin Web Sitesinde Son Tarih' : 'Piyasa Fiyat Arşt. İçin Web Sitesinde Son Tarih'"
                    label-for="text">
                <b-form-input v-model="SatDosya.Yaklasikmaliyetwebsitesontarih" id="date"
                      type="date"></b-form-input>
                  </b-form-group>
                </div> 
                <div class="col-md-2">
                  <button class="btn btn-primary mt-4" type="button" @click="DosyaUpdate()">
                    {{ $t("satdosya.AddEdit.Button") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table-light">
                <tr>
                  <th class="col-md-1"></th>
                  <th>{{ $t("satdosyafirma.Table.Firmaid") }}</th>
                  <th style="width: 85px; text-align: center;">{{ $t("satdosyafirma.Table.Islem") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="Data in TableData" :key="Data.Id">
                  <th class="col-md-1" v-if="Data.Yaklasikmaliyetdosyasi"><b-button
                      v-tooltip="$t('satdosyafirma.Table.Website')" variant="light">
                      <i style="color: #323748" class="fa fa-mouse-pointer"></i>
                    </b-button></th>
                  <th class="col-md-1" v-if="!Data.Yaklasikmaliyetdosyasi"></th>
                  <th scope="row">{{ Data.Firmaadi }}</th>
                  <td style="width: 85px; text-align: center;">
                    <b-button-group>
                      <b-button
                        @click="(FirmaId = Data.Id), (Firmaadi = Data.Firmaadi), (Yaklasikmaliyetdosyasi = Data.Yaklasikmaliyetdosyasi), (Fiyatturu = Fiyatturu)"
                        v-b-modal.satdosyafirmafiyat v-tooltip="$t('satdosyafirma.Table.FiyatTeklifleri')"
                        variant="primary">
                        <i class="far fa-edit "></i>
                      </b-button>
                      <b-button @click="Delete('satdosyafirma', Data.Id)" v-tooltip="$t('satdosyafirma.Table.Sil')"
                        variant="danger">
                        <i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>


                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
              :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
              @input="ChangePage(DefaultPage)">
            </b-pagination>
          </div>


          <div class="border border-primary rounded mt-5 pt-3" v-if="SatDosya.yaklasikmaaliyetbirimfiyat == true && TableData2.length > 0" >   <!-- Yaklaşık maaliyet birim tarafından hazırlanırsa firmalardan gelen teklifleri görüntüleyebilmek için-->
           <h5 style="text-align: center;">Firmalardan Gelen Teklifler</h5>
            <table class="table mb-0">
              <tbody>
                <tr v-for="Data in TableData2" :key="Data.Id">
                  <th class="col-md-1" v-if="Data.Yaklasikmaliyetdosyasi"><b-button
                      v-tooltip="$t('satdosyafirma.Table.Website')" variant="light">
                      <i style="color: #323748" class="fa fa-mouse-pointer"></i>
                    </b-button></th>
                  <th class="col-md-1" v-if="!Data.Yaklasikmaliyetdosyasi"></th>
                  <th scope="row">{{ Data.Firmaadi }}</th>
                  <td style="width: 85px; text-align: center;">
                    <b-button-group>
                      <b-button
                        @click="(FirmaId = Data.Id), (Firmaadi = Data.Firmaadi), (Yaklasikmaliyetdosyasi = Data.Yaklasikmaliyetdosyasi), (Fiyatturu = 2), (Kaydet = false)"
                        v-b-modal.satdosyafirmafiyat v-tooltip="$t('satdosyafirma.Table.FirmaFiyatTeklifleri')"
                        variant="primary">
                        <i class="far fa-eye "></i>
                      </b-button>
                    </b-button-group>


                  </td>
                </tr>
              </tbody>
            </table>
            <br />
          </div>





          <yaklasikmaliyetgorevlileri :satdosyaId="satdosyaId" :Tamamlandi="SatDosya.Tamamlandi" @TableUpdate="Get()" />
          <yaklasikmaliyetcetveli :satdosyaId="satdosyaId" :YMCStartup="YMCStartup" v-if="YMCStartup > 0"
            @GetBirimButceTutari="GetBirimButceTutari" :StrBirimHarcamaLimitTutari="StrBirimHarcamaLimitTutari" />
          <AddEdit v-if="AddEdit" :Firmaturu="1" :FormData="DataUpdate" :AddEdit="AddEdit" :satdosyaId="satdosyaId"
            @TableUpdate="Get(), TutarGuncelle()" />
          <satdosyafirmafiyat v-if="FirmaId" :FirmaId="FirmaId" :Firmaadi="Firmaadi" :AddEdit="AddEdit"
            :Yaklasikmaliyetdosyasi="Yaklasikmaliyetdosyasi" :satdosyaId="satdosyaId" :Fiyatturu="Fiyatturu" :Kaydet="Kaydet"
            @TableUpdate="TutarGuncelle()" />
        </div>
      </div>
    </div>
  </div>
</template>
